export default function (state=null, action) {

	switch (action.type) {
		
	case 'FETCH_SEARCH_KEY_SUCCESS':
		return action.response
				
	case 'LOGOUT':
		return null
		
	default:
		return state
	
	}

}





// WEBPACK FOOTER //
// ./src/reducers/searchKey.js